import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import {
  type Interval,
  type Credentials,
  type Strategy,
  type IssuerId,
  type PortfolioId,
} from 'r/types';

export const intervalAtom = atom('1d' as Interval);
export const intervalTradesAtom = atom('1d' as Interval);

export const wiwAtom = atom(
  typeof window !== 'undefined' ? window.innerWidth : 0,
);

export const adminCredentialsAtom = atomWithStorage<Credentials | undefined>(
  'r-admin-credentials-1',
  undefined,
);

export const strategiesAtom = atom<Array<Strategy>>([]);
export const strategyAtom = atom(
  (get) => (issuerId: IssuerId, portfolioID: PortfolioId) => {
    const strategies = get(strategiesAtom);
    return strategies.find(
      (s) => s.issuerId === issuerId && s.portfolioID === portfolioID,
    )!;
  },
);
